<dw-ui-dialog-box
  [title]="'Doc::CustomerDeliveryNote:SignByCustomer' | abpLocalization"
  [displayFooter]="false"
>
  <div class="signing-dialog-content d-flex flex-column align-items-center gap-4 px-1 py-2">
    <div
      class="signing-qr w-100 d-flex justify-content-center"
      [class.signing-qr-disabled]="isQrDisabled()"
    >
      <qrcode class="d-block lh-1" [qrdata]="qrData()" [width]="qrSize()"></qrcode>
      @if (isQrDisabled()) {
        <div class="signing-qr-overlay d-flex flex-column align-items-center">
          <i
            class="signing-status-icon d-block mb-5 fw-bold"
            [ngClass]="overlayIcon()"
            [class.text-primary]="signingStatus() === SigningStatus.InProgress"
            [class.text-success]="signingStatus() === SigningStatus.Completed"
            [class.text-danger]="signingStatus() === SigningStatus.Cancelled"
            aria-hidden="true"
          ></i>

          <span class="signing-status-message text-center fw-bold">
            {{ overlayMessageKey() | abpLocalization }}
          </span>
        </div>
      }
    </div>

    <div class="signing-divider d-flex align-items-center w-100 text-body-secondary small">
      <span class="text-capitalize">{{ '::or' | abpLocalization }}</span>
    </div>

    <button
      type="button"
      class="btn btn-primary signing-cta d-block mx-auto"
      [disabled]="isQrDisabled()"
      (click)="openSigningPage()"
    >
      {{ 'Doc::CustomerDeliveryNote:ClickToSign' | abpLocalization }}
    </button>
  </div>
</dw-ui-dialog-box>
